var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _this = this;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import attach from "../assets/img/attach.png";
import loader from "../assets/img/loader.gif";
import { FILE_UPLOAD_URL_PATH } from "../globals";
import { postReq } from "../request";
var FileUpload = function (props) {
    var files = props.files, setFiles = props.setFiles;
    var input = useRef(null);
    var _a = useState(0), filesCount = _a[0], setFilesCount = _a[1];
    var _b = useState("completed"), status = _b[0], setStatus = _b[1];
    var _c = useState(["html", "exe", "xhtml"]), excludeExt = _c[0], setExcludeExt = _c[1];
    var _d = useState("https://s3.amazonaws.com/ebuploads2/"), bucketURL = _d[0], setBucketURL = _d[1];
    var iconUrl = function () {
        return status !== "uploading" ? attach : loader;
    };
    useEffect(function () {
        if (files.length > 0) {
            uploadFile(files);
            setFiles([]);
        }
        return function () { };
    }, [files]);
    var uploadFile = function (files) {
        setFilesCount(files.length);
        // Check size and ignore
        if (files.length == 0)
            return;
        // Upload one by one
        setStatus("uploading");
        for (var i = 0; i < files.length; i++) {
            uploadToS3(files[i]);
        }
    };
    var uploadToS3 = function (file) {
        // Validate
        if (!isValidFile(file))
            return;
        //Change unique file name
        setFilePath(file);
        var that = _this;
        var wait = postReq(FILE_UPLOAD_URL_PATH + "?file=" + file.file_resource, {
            fileUrl: file.file_resource,
        });
        wait
            .then(function (response) {
            file.file_resource = response.data.fileURL;
            uploadToAWSBucket(getFileData(file), file);
        })
            .catch(function () { });
        //this.sync(this.getRestURL("api/panel/contentbox/repo/getFilePath?file=" +file.file_resource) ,{"fileUrl":file.file_resource},function(data){
        //	file.file_resource = data.fileURL;
        //	that.uploadToAWSBucket(that.getFileData(file), file);
        //	})
    };
    /**
     * UPload to amazon
     *
     * @param form_data
     * @param file
     */
    var uploadToAWSBucket = function (form_data, file) {
        var that = _this;
        // Construct http request for post request
        var xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener("progress", function (evt) { }, false);
        xhr.addEventListener("load", function (evt) {
            var statusCode = evt.target
                ? evt.target.status
                : evt.currentTarget.status;
            emitEvent(statusCode >= 200 && statusCode <= 300 ? "success" : "error", file);
        }, false);
        xhr.addEventListener("error", function (evt) {
            file.error_mssg =
                "Sorry, you cannot upload files at this moment. Please try again later.";
            emitEvent("error", file);
        }, false);
        xhr.addEventListener("abort", function (evt) {
            file.error_mssg =
                "Sorry, you cannot upload files at this moment. Please try again later.";
            emitEvent("error", file);
        }, false);
        // Must be last line before send
        xhr.open("POST", bucketURL, true);
        xhr.send(form_data);
    };
    var setFilePath = function (file) {
        var file_name = file.name.split(".")[0];
        var file_extension = file.name.split(".").pop();
        file.file_resource =
            "uploads/" +
                file_name.replace(/[^a-zA-Z0-9]/g, "_") +
                "." +
                file_extension;
        file.bucketURL = bucketURL;
    };
    var getFileData = function (file) {
        var fd = new FormData();
        // Construct post data
        fd.append("key", file.file_resource);
        fd.append("acl", "public-read");
        fd.append("AWSAccessKeyId", "AKIAIUBC6PDU7ZVBXFJA");
        fd.append("policy", "ewogICJleHBpcmF0aW9uIjogIjIwMjktMDEtMDFUMTI6MDA6MDAuMDAwWiIsCiAgImNvbmRpdGlvbnMiOiBbCiAgICB7ImJ1Y2tldCI6ICJlYnVwbG9hZHMyIiB9LAogICAgeyJhY2wiOiAicHVibGljLXJlYWQiIH0sCiAgICBbInN0YXJ0cy13aXRoIiwgIiRrZXkiLCAidXBsb2Fkcy8iXSwKICAgIFsic3RhcnRzLXdpdGgiLCAiJENvbnRlbnQtVHlwZSIsICIiXQogIF0KfQo=");
        fd.append("signature", "yQfJQnt5Jdbomu680QKvK4oD15c=");
        // fd.append('Content-Type', file.type | 'binary/octet-stream');
        fd.append("Content-Type", "binary/octet-stream");
        if (file.type == 'image/svg+xml')
            fd.set('Content-Type', file.type);
        fd.append("file", file);
        return fd;
    };
    var isValidFile = function (file) {
        var file_name = file.name.split(".")[0];
        var file_extension = file.name.split(".").pop();
        if (excludeExt.includes(file_extension)) {
            file.error_mssg = "Sorry, you cannot upload such files.";
            emitEvent("error", file);
            return false;
        }
        // Large file limit (5MB)
        if (file.size > 50 * 1024 * 1024) {
            file.error_mssg = "Sorry, you cannot upload files larger than 50 MB.";
            emitEvent("error", file);
            return false;
        }
        return true;
    };
    var emitEvent = function (status, file) {
        props.fileUploadCallback(status, file);
        // File count change for completed status
        if (status == "success") {
            setStatus("completed");
            if (input.current)
                input.current.setAttribute("value", "");
        }
    };
    return (_jsxs("div", __assign({ className: "chat__actions-item chat__attachments" }, { children: [_jsx("input", { ref: input, type: "file", multiple: true, id: "attachments", value: "", onChange: function (e) { return uploadFile(e.currentTarget.files); } }), _jsx("label", __assign({ htmlFor: "attachments", className: "chat__actions-item-trigger" }, { children: status !== "uploading" ? (_jsxs("svg", __assign({ width: "16", height: "16", fill: "#757575", xmlns: "http://www.w3.org/2000/svg", version: "1.1", id: "Layer_1", x: "0px", y: "0px", viewBox: "0 0 16 16" }, { children: [" ", _jsxs("g", { children: [" ", _jsx("path", { d: "M5.3,13.5C5.3,13.5,5.3,13.5,5.3,13.5c-1.1,0-2.1-0.4-2.8-1.2c-1.5-1.5-1.5-4,0-5.6l4.2-4.2   c0.3-0.3,0.7-0.3,0.9,0c0.3,0.3,0.3,0.7,0,0.9L3.4,7.7c-1,1-1,2.7,0,3.7c0.5,0.5,1.2,0.8,1.9,0.8c0.8,0,1.4-0.3,1.9-0.8l5.9-5.9   c0.4-0.4,0.4-1.1,0-1.5c-0.2-0.2-0.5-0.3-0.7-0.3l0,0c-0.3,0-0.5,0.1-0.7,0.3L5.7,10c-0.3,0.3-0.7,0.3-0.9,0s-0.3-0.7,0-0.9   l5.9-5.9c0.4-0.4,1-0.7,1.7-0.7l0,0c0.6,0,1.2,0.2,1.7,0.7c0.9,0.9,0.9,2.4,0,3.3l-5.9,5.9C7.3,13.1,6.3,13.5,5.3,13.5z" }), " "] }), " "] }))) : (_jsx("img", { src: loader, alt: "Attachments", className: "chat__actions-item-trigger" })) }))] })));
};
export default FileUpload;
